import { useContext, useState } from 'react';
import Unit from '../../../types/Unit/Unit';
import DamageDisplay from './DamageDisplay/DamageDisplay';
import { convertToUnit } from '../../../hooks/useFactionData/useFactionData.util';
import SelectUnit from '../../../components/SelectUnit/SelectUnit';
import { FactionContext } from '../../../Contexts/FactionContext/FactionContext';

function Damage() {
  const { faction, updateFaction } = useContext(FactionContext);
  const [selectedUnit, setSelectedUnit] = useState<Unit | undefined>();

  return (
    <div>
      <SelectUnit
        faction={faction}
        onUnitSelected={(unit, factionName) => {
          setSelectedUnit(convertToUnit(unit));
          updateFaction(factionName);
        }}
      />
      {selectedUnit && <DamageDisplay 
        unit={selectedUnit}
      />}
    </div>
  );
}
  
export default Damage;